import { z } from "zod";
import { BookingSchema } from "../response/ShowBookingResponse";
import { PaginationSchema } from "../../pagination/response/PaginationResponse";

/**
 * Schema for rates in Switch Reservation
 */
const rateSchema = z.object({
  date: z.string(),
  rate: z.coerce.number().min(0, 'Rate must be a positive number'),
});

/**
 * Schema for SwitchCandidate (GET /api/v4/booking/switch-reservation-candidates)
 */
export const SwitchCandidateSchema = z.object({
  id: z.string(),
  customer_name: z.string(),
  invoice_number: z.string(),
  checkin_date: z.string(),
  checkout_date: z.string(),
  room_type_name: z.string().optional(),
  room_type_id: z.string().optional(),
  room_number: z.string().optional(),
  booking_id: z.string(),
  total_rate: z.coerce.string().optional(),
  rates: z.array(rateSchema).optional(),
  // Full booking data if available
  booking: BookingSchema.optional(),
});

/**
 * Schema for paginated SwitchCandidate response
 */
export const SwitchCandidatePaginatedResponseSchema = z.object({
  success: z.boolean(),
  data: z.array(SwitchCandidateSchema),
  pagination: PaginationSchema
});

/**
 * Schema for SwitchReservationPayload (POST /api/v4/booking/switch-reservation)
 */
export const SwitchReservationPayloadSchema = z.object({
  source_booking_room_id: z.string().uuid(),
  target_booking_room_id: z.string().uuid(),
  source_rates: z.array(rateSchema).optional(),
  target_rates: z.array(rateSchema).optional(),
});

export type SwitchCandidateType = z.infer<typeof SwitchCandidateSchema>;
export type SwitchCandidatePaginatedResponseType = z.infer<typeof SwitchCandidatePaginatedResponseSchema>;
export type SwitchReservationPayloadType = z.infer<typeof SwitchReservationPayloadSchema>;
